import React from "react"
import { Modal, Row, Button, Col } from 'react-bootstrap'

const ChartInCompleteOnSubmitModal = (props) => {
  const { show, data, chartIncompleteDuringApprovalProcess } = props
  const handleHide = () => {
    props.toggleSaveAndFinishOnModalClose()
    props.toggleShow()
  }

  const formatModelName = (name, index = 0) => {
    let formattedModelName = name
    if (name === "Antibiotics Uses") {
      formattedModelName = "Antibiotics Use"
    } 

    if (formattedModelName === "ICU Admissions" || formattedModelName === "Cefiderocol Adverse Drug Reactions") {
      formattedModelName += ` ${index + 1}`
    }

    return formattedModelName
  }
  
  const generateNestedFields = (item) => {
    const nestedField = Object.keys(item).find(key => Array.isArray(item[key]))
    if (nestedField) {
      const nestedItems = item[nestedField]
      return nestedItems.map((object, index) => {
        if (object.complete) {
          return null
        }

        return (
          <li key={object.id}>
            {formatModelName(object.model, index)}
            <ul>
              {generateNestedFields(object)}
            </ul>
          </li>
        )
      })
    } else {
      return null
    }
  }
  
  return (
    <Modal 
      show={show} 
      onHide={handleHide} 
      dialogClassName="modal-wide"
    >
      <Modal.Header closeButton>
        Incomplete Chart
      </Modal.Header>

      <Modal.Body>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12}>
            <p>
              {chartIncompleteDuringApprovalProcess ?
                `The chart that you are approving has incomplete data in the sections listed below. Please click the Requires Revisions button to send the chart back to its original creator for completion.`
                :
                `You have submitted a patient chart before completing all required fields. Please go back and complete the empty questions in the following section(s) of the chart:`
              }
            </p>
            {data.length > 0 ?
              <div className="indented-row">
                <ul>
                  {data.map((item, index) => {
                    if (item.complete) {
                      return null
                    }

                    return (
                      <li key={item.id ? item.id : item.model}>
                        {formatModelName(item.model, index)}
                        <ul>
                          {generateNestedFields(item)}
                        </ul>
                      </li>
                    )
                  })
                  }
                </ul>
              </div>
              :
              null
            }
          </Col>
        </Row>
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={handleHide} variant="secondary">
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ChartInCompleteOnSubmitModal
